import { useState, useMemo } from "react";
import { LanguageContext, useLang } from "@/context/LanguageContext";

// Lets a single article/katha switch its OWN content language (EN ⇄ हिं)
// without changing the site-wide language. UI chrome (t/L labels) stays global;
// content pickers (pick/pickTitle/pickSecondary/pickDesc/isDeva/lang) use the reading language.
export default function ArticleLangScope({ children, testid = "article" }) {
  const parent = useLang();
  const [readLang, setReadLang] = useState(parent.lang === "en" ? "en" : "hi");

  const value = useMemo(() => {
    const pick = (deva, en) => (readLang === "en" ? en : deva);
    const L = (obj) => (obj && (obj[readLang] || obj.en || obj.hi)) || "";
    const pickTitle = (item) => {
      if (!item) return "";
      if (readLang === "hi") return item.hindi_title || item.devanagari_title || item.title || "";
      return item.english_title || item.title || item.devanagari_title || "";
    };
    const pickSecondary = (item) => {
      if (!item) return "";
      const dual = item.dual_script ?? ["mantra", "stotra", "sukta"].includes(item.type);
      if (!dual) return "";
      const primary = pickTitle(item);
      if (readLang === "en") return item.devanagari_title && item.devanagari_title !== primary ? item.devanagari_title : "";
      return item.title && item.title !== primary ? item.title : "";
    };
    const pickDesc = (item) => {
      if (!item) return "";
      if (readLang === "hi") return item.description_hi || item.description || "";
      return item.description || item.description_hi || "";
    };
    return { ...parent, lang: readLang, isDeva: readLang !== "en", pick, L, pickTitle, pickSecondary, pickDesc };
  }, [parent, readLang]);

  return (
    <LanguageContext.Provider value={value}>
      <div className="mx-auto flex max-w-7xl items-center gap-2 px-5 pb-4 pt-5 md:px-8">
        <span className="text-xs uppercase tracking-wider text-ink-3">{parent.pick("इस लेख की भाषा", "Read this in")}</span>
        <div className="inline-flex overflow-hidden rounded-full border border-[var(--saffron)]/40 bg-[var(--surface-alt)]" data-testid={`${testid}-lang-toggle`}>
          <button type="button" onClick={() => setReadLang("en")} data-testid={`${testid}-lang-en`}
            className={`px-3.5 py-1 text-xs font-medium transition-colors ${readLang === "en" ? "bg-[var(--saffron)] text-white" : "text-ink-2 hover:text-saffron"}`}>English</button>
          <button type="button" onClick={() => setReadLang("hi")} data-testid={`${testid}-lang-hi`}
            className={`px-3.5 py-1 font-deva text-xs font-medium transition-colors ${readLang === "hi" ? "bg-[var(--saffron)] text-white" : "text-ink-2 hover:text-saffron"}`}>हिन्दी</button>
        </div>
      </div>
      {children}
    </LanguageContext.Provider>
  );
}
